import { render, staticRenderFns } from "./xszm.vue?vue&type=template&id=a08a0ec4&scoped=true"
import script from "./xszm.vue?vue&type=script&lang=js"
export * from "./xszm.vue?vue&type=script&lang=js"
import style0 from "./xszm.vue?vue&type=style&index=0&id=a08a0ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a08a0ec4",
  null
  
)

export default component.exports